var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBulCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "white",
    stroke: "#646782"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88125 6L8 10.0892L12.1187 6.00637L13 6.90446L8 12L3 6.90446L3.88125 6Z",
    fill: "#646782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBulCircleDown);
export default __webpack_public_path__ + "static/media/ico-bul-circle-down.eeb3ad04b9eb44ea8d0cfbbced66be7e.svg";
export { ForwardRef as ReactComponent };